import { useCallback, useEffect } from 'react';

export const useBodyLockScroll = (isLock: boolean) => {
  const lockScroll = useCallback(() => {
    const body = document.querySelector('body') as HTMLElement;
    body.style.overflow = 'hidden';
  }, []);

  const unLockScroll = useCallback(() => {
    const body = document.querySelector('body') as HTMLElement;
    body.style.removeProperty('overflow');
  }, []);

  useEffect(() => {
    if (isLock) {
      lockScroll();
    } else {
      unLockScroll();
    }
  }, [isLock, lockScroll, unLockScroll]);

  // componentWillUnmount
  useEffect(() => () => unLockScroll(), [unLockScroll]);
};
